import React, { ReactNode } from 'react';

import { CardValue } from 'common/components/Card/card.styled';

interface IProps {
  value?: string | number | ReactNode;
}

export const InfoCardValue = ({ value }: IProps) => {
  return <CardValue>{value}</CardValue>;
};
